import { TAppState } from '../../types/appState';

export const customChatParamsSelector = (state: TAppState) => {
  const { chatWindow, chatList, openedChats } = state;
  const { currentOpenedChatId } = chatWindow;
  const { removedFromArchiveChatId, removedFromSpamChatId } = chatList;

  const chatId = (currentOpenedChatId || removedFromArchiveChatId || removedFromSpamChatId) as string;
  const chat = openedChats[chatId] || {};
  const { customChatParams } = chat;

  return customChatParams || null;
};
